import styled from 'styled-components';

export const ContactUsSection = styled.div`
  padding: 50px 0;
  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const ContactBoxes = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
`;

export const ContactCardBox = styled.li`
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 50px;
  background: #f7f7f7;
  margin: 1rem 0;
  width: 48%;

  @media (max-width: 992px) {
    padding: 25px 15px;
  }

  @media (max-width: 768px) {
    width: 100%;
    :first-child {
      margin-top: 0;
    }
  }
`;

export const BoxDetails = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    padding: 30px 0;
    text-align: center;
  }
`;

export const ContactIcon = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 38px;

  &.twtr_icon {
    svg {
      width: 31px;
      height: 28px;
      fill: #1b7bdd;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-flow: row;
  }
`;

export const ContactDetails = styled.div`
  margin: 0 4rem;
  width: 160px;

  .title {
    color: #1b7bdd;
    font-size: 12px;
    line-height: 30px;
    text-transform: uppercase;

    @media (max-width: 768px) {
      margin: 1.25rem 0;
      text-align: center;
    }
  }

  p {
    margin: 0 0 0.5rem;
    font-size: 18px;
    a {
      color: #000;
    }
  }

  .twtr-title {
    margin-right: 0.5rem !important;
  }

  .txt-decoration:hover {
    text-decoration: underline;
  }

  @media (max-width: 992px) {
    margin: 0 2rem;
  }

  &[dir='rtl'] {
    display: flex;
    align-items: center;

    a {
      margin-right: 10px;
    }
  }
`;

export const Seperator = styled.div`
  margin: 1rem 0;
  height: 1px;
  width: 100%;
  background: #ebebeb;
`;
